import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import SiteHeader from '../components/SiteHeader'
import Breadcrumbs from '../components/Breadcrumbs'
import {
    MDBAnimation,
    MDBContainer,
    MDBRow,
    MDBDatatable,
    MDBBtn,
    MDBIcon,
    MDBCol,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBInput,
    MDBSelect,
    MDBFile,
} from 'mdb-react-ui-kit'
import encryption from '../services/encryption'
import formService from '../services/forms'
import modulePermissions from '../utilities/modulePermissions'
import auth from '../services/authentication'

export default function Forms() {

    const moduleName = 'form';
    const navigateTo = useNavigate();
    const { version_id } = useParams();
    const [selectedProfile, setSelectedProfile] = useState(null);

    const [modalAddShow, setModalAddShow] = useState(false);
    const [modalEditShow, setModalEditShow] = useState(false);
    const [modalDeleteShow, setModalDeleteShow] = useState(false);
    const [entryId, setEntryId] = useState(null);
    const [state, setState] = useState({
        version_id: version_id,
        formName: '',
        fields: [],
    });

    const [modules, setModules] = useState({});

    const breadCrumbsData = [
        {
            text: 'Inicio',
            href: `/home`
        },
        {
            text: 'Versiones',
            href: `/version/${version_id}`
        },
        {
            text: 'Formularios',
        }
    ];

    const handleSelectedProfile = () => {
        let token = localStorage.getItem('selectedProfile');
        if (token) {
            let descryptedToken = encryption.decrypt(token);
            setSelectedProfile(descryptedToken);
        }
    }

    const toggleAddModal = () => {
        if (modalAddShow === false) {
            setState({
                version_id: version_id,
                formName: '',
                fields: [],
            });
        }
        setModalAddShow(!modalAddShow);
    }

    const toggleEditModal = (newState) => {
        setModalEditShow(newState);
    }

    const toggleDeleteModal = (newState) => {
        setModalDeleteShow(newState);
    }

    const btnActionEdit = (item, id) => {
        let newState = { ...item };
        delete newState.id;
        setEntryId(id);
        setState(newState);
        toggleEditModal(true);
    }

    const btnActionDelete = (item, id) => {
        let newState = { ...item };
        delete newState.id;
        setEntryId(id);
        setState(newState);
        toggleDeleteModal(true);
    }

    const [asyncData, setAsyncData] = useState({
        columns: [
            {
                label: 'ID',
                field: 'id',
            },
            {
                label: 'Nombre',
                field: 'formName',
            },
            {
                label: 'Revisión',
                field: 'formRevision',
            },
            {
                label: 'Cantidad Campos',
                field: 'fieldAmount'
            },
            {
                label: 'Acciones',
                field: 'actions',
            },
        ],
        rows: []
    });

    const [dataLoading, setDataLoading] = useState(false);

    const handleDataLoad = async () => {

        const forms = await formService.listByVersion(version_id)
        setAsyncData({
            columns: asyncData.columns,
            rows: forms.map((item, index) => {
                return {
                    id: index + 1,
                    formName: item.formName,
                    formRevision: item.formRevision,
                    fieldAmount: item.fields.length,
                    actions: <>
                        {
                            selectedProfile && modules?.forms?.includes('update') && (
                                <MDBBtn color='info' size='lg' className='me-2' floating onClick={() => btnActionEdit(item, item.id)}>
                                    <MDBIcon icon='edit' />
                                </MDBBtn>
                            )
                        }
                        {
                            selectedProfile && modules?.forms?.includes('delete') && (
                                <MDBBtn color='danger' size='lg' className='me-2' floating onClick={() => btnActionDelete(item, item.id)}>
                                    <MDBIcon icon='trash' />
                                </MDBBtn>
                            )
                        }
                        {
                            selectedProfile && modules?.forms?.includes('internal') && (
                                <MDBBtn
                                    color='secondary'
                                    size='lg'
                                    floating
                                    type='button'
                                    onClick={() => {
                                        navigateTo(`/${moduleName}/${version_id}/${item.id}`);
                                    }}
                                >
                                    <MDBIcon icon='eye' />
                                </MDBBtn>
                            )
                        }
                    </>
                }
            })

        })
    }

    const handleCreate = async () => {
        await formService.import(state);
        handleDataLoad();
        toggleAddModal();
        setState({
            version_id: version_id,
            formName: '',
            fields: []
        });
    }

    const handleUpdate = async () => {
        await formService.update(entryId, {
            ...state
        });
        handleDataLoad();
        toggleEditModal(false);
    }

    const handleDelete = async () => {
        await formService.remove(entryId);
        handleDataLoad();
        setState({
            version_id: version_id,
            formName: '',
            fields: [],
        });
        toggleDeleteModal(false);
    }

    useEffect(() => {
        handleSelectedProfile();
    }, []);

    useEffect(() => {
        handleDataLoad();
    }, [dataLoading, asyncData.columns, modules, selectedProfile]);

    useEffect(() => {
        if (asyncData.rows.length === 0) {
            setDataLoading(true);
        } else {
            setDataLoading(false);
        }
    }, [asyncData.rows]);
    const handlePageModules = async () => {
        let modulesData = {};
        modulesData = {
            forms: []
        }
        let available = false;

        available = await modulePermissions(selectedProfile.roleName, 'forms', 'create');
        if (available) modulesData.forms.push('create');
        available = await modulePermissions(selectedProfile.roleName, 'forms', 'update');
        if (available) modulesData.forms.push('update');
        available = await modulePermissions(selectedProfile.roleName, 'forms', 'delete');
        if (available) modulesData.forms.push('delete');
        available = await modulePermissions(selectedProfile.roleName, 'forms', 'internal');
        if (available) modulesData.forms.push('internal');

        setModules(modulesData);
    }

    useEffect(() => {
    }, [modules]);

    useEffect(() => {
        if (selectedProfile) {
            handlePageModules();
        }
    }, [selectedProfile]);

    return (
        <>
            <SiteHeader
                selectedProfile={selectedProfile}
            />
            <MDBAnimation
                animation='fade-in'
                start='onLoad'
                duration={700}
            >
                <MDBRow className='my-4 ms-4'>
                    <Breadcrumbs
                        items={breadCrumbsData}
                    />
                </MDBRow>
                <MDBContainer>
                    <MDBRow className='my-4 ms-4'>
                        <h4>Formularios</h4>
                    </MDBRow>
                    {
                        selectedProfile && modules?.forms?.includes('create') && (
                            <MDBRow className='text-end'>
                                <MDBCol className='me-0 pe-0'>
                                    <MDBBtn color='primary' className='my-4' size='lg' floating onClick={() => {
                                        toggleAddModal();
                                    }}>
                                        <MDBIcon icon='plus' />
                                    </MDBBtn>
                                </MDBCol>
                            </MDBRow>
                        )
                    }
                    <MDBRow>
                        <MDBDatatable
                            data={asyncData}
                            rowsText='Filas'
                            ofText='de'
                            searchLabel='Buscar'
                            search
                            noFoundMessage='No se encontraron resultados'
                            isLoading={dataLoading}
                            searchInputProps={
                                {
                                    'className': 'pb-1',
                                }
                            }
                        />
                    </MDBRow>
                </MDBContainer>
            </MDBAnimation>

            <MDBModal tabIndex='-1' show={modalAddShow} setShow={setModalAddShow}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Agregar formulario</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={toggleAddModal}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <input type='hidden' value={state.version_id} />
                            <MDBInput
                                label='Nombre formulario'
                                value={state.formName}
                                onChange={(e) => {
                                    setState({
                                        ...state,
                                        formName: e.target.value
                                    });
                                }}
                                className='mb-4'
                            />
                            <MDBFile
                                label='Fichero .JSON'
                                onChange={(e) => {
                                    if (e.target.files.length > 0) {
                                        const fileReader = new FileReader();
                                        fileReader.readAsText(e.target.files[0], "UTF-8")
                                        fileReader.onload = eFile => {
                                            let newData = JSON.parse(eFile.target.result);
                                            setState({
                                                ...state,
                                                fields: newData
                                            })
                                        }
                                    }
                                }}
                            />

                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='secondary' outline onClick={toggleAddModal}>
                                Cancelar
                            </MDBBtn>
                            <MDBBtn
                                color='primary'
                                onClick={
                                    () => {
                                        handleCreate()
                                    }
                                }

                            >Insertar
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <MDBModal tabIndex='-1' show={modalEditShow} setShow={setModalEditShow}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Editar formulario</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={
                                () => toggleEditModal(false)
                            }></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <input type='hidden' value={state.version_id} />
                            <MDBInput
                                label='Nombre formulario'
                                value={state.formName}
                                onChange={(e) => {
                                    setState({
                                        ...state,
                                        formName: e.target.value
                                    });
                                }}
                                className='mb-4'
                            />
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='secondary' outline onClick={
                                () => toggleEditModal(false)
                            }>
                                Cancelar
                            </MDBBtn>
                            <MDBBtn
                                onClick={() => {
                                    handleUpdate();
                                }}
                            >Actualizar
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <MDBModal tabIndex='-1' show={modalDeleteShow} setShow={setModalDeleteShow}>
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Eliminar formulario</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={
                                () => toggleDeleteModal(false)
                            }></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p>¿Está seguro que desea eliminar el formulario {state.formName}?</p>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='secondary' outline onClick={
                                () => toggleDeleteModal(false)
                            }>
                                Cancelar
                            </MDBBtn>
                            <MDBBtn
                                onClick={() => {
                                    handleDelete();
                                }}
                            >Eliminar
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    )
}
